<template>
  <div class="welcome">
    <h1>Welcome to Cappture</h1>
    <h3>Thanks for signing up, let's get started.</h3>
    <ol>
      <li>
        <a href="https://s3-us-west-2.amazonaws.com/devetry-stuff/cappture-extension-2018-05-24.zip">
          Download the extension
        </a>
      </li>
      <li>
        Visit the site you want to test
      </li>
      <li>
        Click the icon to open the extension, and sign in.
      </li>
      <li>
        Record your testing, and mark things that go wrong.
      </li>
      <li>
        Share your findings with teammates
      </li>
    </ol>
  </div>
</template>

<script>
export default {
  name: 'Welcome',
};
</script>

<style lang="scss" scoped>
.welcome {
  margin: 0 auto;
  margin-top: 300px;
  width: 400px;
}
</style>



// WEBPACK FOOTER //
// src/components/Welcome.vue